// import 'bootstrap';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
//
// Push-notifications like functionality
// https://getbootstrap.com/docs/4.3/components/toasts/
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/util';
//
// needed for tooltips and popovers
// https://getbootstrap.com/docs/4.3/getting-started/javascript/#sanitizer
// import 'bootstrap/js/dist/tools/sanitizer';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js